module.exports = __webpack_public_path__ + "img/daftpunktocat-guy.23b8ca23.gif";